import { render, staticRenderFns } from "./LegacyDropzone.vue?vue&type=template&id=10be2b56&scoped=true&"
import script from "./LegacyDropzone.vue?vue&type=script&lang=js&"
export * from "./LegacyDropzone.vue?vue&type=script&lang=js&"
import style0 from "./LegacyDropzone.vue?vue&type=style&index=0&id=10be2b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be2b56",
  null
  
)

export default component.exports